import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Filters } from 'framework/list';
import CandidateListFiltersLayout from 'domain/recruiting/candidate/Timeline/shared/filter/CandidateListFiltersLayout';
import CandidateTimelineRecordTypeFilter from 'domain/recruiting/candidate/Timeline/shared/filter/CandidateTimelineRecordTypeFilter';
import { CANDIDATE_TIMELINE_MESSAGE_CONTEXT, useCandidateService } from 'domain/shared/candidate';
import useCandidateApplicationItem from 'domain/recruiting/candidate/Timeline/application/candidateApplicationRegistry';
import useCandidateNoteItem from 'domain/recruiting/candidate/Timeline/note/note/candidateNoteRegistry';
import useCandidateSystemNoteItem from 'domain/recruiting/candidate/Timeline/note/systemNote/candidateSystemNoteRegistry';
import useCandidateOfferItem from 'domain/recruiting/candidate/Timeline/offer/candidateOfferRegistry';
import useCandidateResumeItem from 'domain/recruiting/candidate/Timeline/resume/candidateResumeRegistry';
import PersonTimeline from 'domain/shared/timeline/person';
import Description from '@mui/icons-material/Description';
import EditNote from '@mui/icons-material/EditNote';
import useCandidateExpectedCompensationItem from '../../../Timeline/expectedCompensation/expectedCompensationRegistry';
import AddTimelineItemsButtons from 'domain/shared/timeline/person/AddTimelineItemsButtons';
import { AddTimelineItemInputProps } from 'domain/shared/timeline/person/PersonTimelinePageLayout';
import { TimelineRegistry } from 'framework/ui/timeline';
import CandidateTimelineHeader from './CandidateTimelineHeader';

const NOTE_TAG_SOURCE = 'note.tag';

const CandidateTimeline = () => {
  const { id: candidateId } = useParams<Dictionary<string>>();
  const { searchTimelineItems, createTimelineItem, getTimelinePageById } = useCandidateService();

  const noteRegistry = useCandidateNoteItem();
  const offerRegistry = useCandidateOfferItem();
  const resumeRegistry = useCandidateResumeItem();
  const applicationRegistry = useCandidateApplicationItem();
  const systemNoteRegistry = useCandidateSystemNoteItem();
  const expectedCompensationRegistry = useCandidateExpectedCompensationItem();

  const filters = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Filters>
        <CandidateListFiltersLayout>
          <CandidateTimelineRecordTypeFilter cleanableFilters={[NOTE_TAG_SOURCE]} source="type" />
        </CandidateListFiltersLayout>
      </Filters>
    </Box>
  );

  const formConfig = {
    CreateCandidateNoteForm: {
      icon: <EditNote />,
      text: 'New note',
    },
    CreateCandidateOfferForm: {
      icon: <Description />,
      text: 'New offer',
    },
    default: {
      icon: <EditNote />,
      text: 'New entry',
    },
  };

  const TimelineItemInput = (props: AddTimelineItemInputProps) => (
    <AddTimelineItemsButtons {...props} registries={[noteRegistry, offerRegistry] as unknown as TimelineRegistry[]} />
  );

  const candidateRegistries = [
    noteRegistry,
    offerRegistry,
    resumeRegistry,
    systemNoteRegistry,
    applicationRegistry,
    expectedCompensationRegistry,
  ] as unknown as TimelineRegistry[];

  return (
    <PersonTimeline
      entityId={candidateId!}
      registries={candidateRegistries}
      getTimelineItems={searchTimelineItems}
      createTimelineItem={createTimelineItem}
      getTimelinePageById={getTimelinePageById}
      filter={filters}
      messageContext={CANDIDATE_TIMELINE_MESSAGE_CONTEXT}
      AddTimelineItemInput={TimelineItemInput}
      formConfig={formConfig}
      timelineHeader={<CandidateTimelineHeader />}
      noEntriesMessage="No entries in this candidate timeline yet."
      timelineEntryIdSource="timelineEntryId"
    />
  );
};

export default CandidateTimeline;
